import { isValidSessionManagementId } from "./accountSessionsPolicy";

export const ACCOUNT_SESSIONS_URL = "/api/account/sessions";

export const accountSessionListRequest = () => ({
  method: "GET",
  url: ACCOUNT_SESSIONS_URL,
});

export const accountSessionRevocationRequest = ({kind, sessionManagementId}) => {
  if (kind === "others") {
    return {method: "DELETE", url: `${ACCOUNT_SESSIONS_URL}/others`};
  }
  if (kind === "all") {
    return {method: "DELETE", url: ACCOUNT_SESSIONS_URL};
  }
  if (kind === "single" && isValidSessionManagementId(sessionManagementId)) {
    return {
      method: "DELETE",
      url: `${ACCOUNT_SESSIONS_URL}/${encodeURIComponent(sessionManagementId)}`,
    };
  }
  throw new Error("A valid account-session revocation action is required.");
};
